module.exports = __webpack_public_path__ + "static/media/baleine1.0f55fee9.jpg";